// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1QnqE","label":"Section_label__24M3F","contentWrap":"Section_contentWrap__3ro5S","footer":"Section_footer__3FwUB","footerInner":"Section_footerInner__1PT1a"};